import { X } from 'lucide-react'

import { Button } from '@/components/ui/button'
import type { Selection } from '@/lib/cross-filter'
import { formatFieldValue, type ReportField } from '@/lib/cube-report'
import { formatDateOnly } from '@/lib/format'
import { messages } from '@/lib/messages'

function valueText(selection: Selection, field: ReportField | undefined): string {
  if (selection.kind === 'range') {
    const [from, to] = selection.values[0].split('..')
    return `${formatDateOnly(from)} – ${formatDateOnly(to)}`
  }
  return selection.values
    .map((value) => (field ? formatFieldValue(field, value) : value))
    .join(', ')
}

/** Çapraz filtre seçimlerinin chip'leri; seçim yoksa hiçbir şey çizmez. */
export function CrossFilterChips({
  selections,
  resolveField,
  onChange,
}: {
  selections: Selection[]
  /** Üyenin kısa adından alan (etiket ve değer biçimi için). */
  resolveField: (member: string) => ReportField | undefined
  onChange: (next: Selection[]) => void
}) {
  if (selections.length === 0) return null
  return (
    <div className="flex flex-wrap items-center gap-2">
      {selections.map((selection) => {
        const field = resolveField(selection.member)
        const label = field?.label ?? selection.member
        return (
          <span
            key={`${selection.source}~${selection.member}`}
            className="bg-secondary text-secondary-foreground inline-flex items-center gap-1 rounded-full py-0.5 pr-1 pl-3 text-sm"
          >
            {label}: {valueText(selection, field)}
            <button
              type="button"
              aria-label={messages.crossFilter.remove(label)}
              className="hover:bg-accent rounded-full p-1"
              onClick={() => onChange(selections.filter((item) => item !== selection))}
            >
              <X className="size-3" />
            </button>
          </span>
        )
      })}
      {selections.length > 1 && (
        <Button variant="ghost" size="sm" onClick={() => onChange([])}>
          {messages.crossFilter.clear}
        </Button>
      )}
    </div>
  )
}
